import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Box, Chip, Button } from "@mui/material";
import { useTemplateFontSettings } from "styles/templateFontSettings";
import { useSelector } from "react-redux";
import { getUserFullName } from "app/utils/appHelpers";
import { getLocaleDateWithTimeCustomV2 } from "app/utils/appHelpers";
import config from "../../../config";

function AgendaTemplateItemDialog({ onClose, open, agendaTemplate }) {
    const { titleSize, lineHeight } = useTemplateFontSettings();
    const userList = useSelector(state => state.user.data);
    const user = userList.find(x => x.id === agendaTemplate?.userId);

    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="md">
            <DialogTitle style={{ fontSize: titleSize, lineHeight: lineHeight }}>
                Gündem Şablonu Detayı
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ p: 2 }}>
                    <Typography variant="h6" gutterBottom>
                        {agendaTemplate?.title}
                    </Typography>

                    <Box sx={{ mb: 2 }}>
                        <Chip
                            label={`Oluşturan: ${getUserFullName(user)}`}
                            color="primary"
                            size="small"
                            sx={{ mr: 1 }}
                        />
                        <Chip
                            label={`Güncelleme: ${getLocaleDateWithTimeCustomV2("tr", agendaTemplate?.pdate)}`}
                            color="secondary"
                            size="small"
                        />
                    </Box>

                    <Typography variant="body1" sx={{
                        whiteSpace: 'pre-wrap',
                        backgroundColor: '#f5f5f5',
                        p: 2,
                        borderRadius: 1,
                        border: '1px solid #e0e0e0'
                    }}>
                        {agendaTemplate?.body}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={onClose}>
                    Kapat
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AgendaTemplateItemDialog